export const derivePublicLocaleInfo = ({
  isPublicI18n,
  getPublicLocaleInfo
}) => {
  if (getPublicLocaleInfo) {
    if (!isPublicI18n) {
      throw new Error(`Invariant: expected languageSupport="public" when getPublicLocaleInfo is provided`);
    }
    return getPublicLocaleInfo();
  }
};